import { connect } from 'react-redux';
import { compose } from 'redux';
import { Card, Row, Col } from 'react-bootstrap';
import PropertyPickerVertical from './components/PropertyPickerVertical';
import BaseFeature from './BaseFeature';
import { fetchDriverProperties } from '../../../../../../actions';
import { currentSettingModes } from '../../../../../../utils/constantValues';
import PropertyDropdownUnlabeled from './components/PropertyDropdownUnlabeled';
import { OPERATING_CURRENT } from '../../../../../../utils/constantFeatures';
import CurrentChart from './charts/CurrentChart'
import { Trans, withTranslation } from 'react-i18next';

class CurrentSetting extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[OPERATING_CURRENT.enable].value === "1" ? true : false,
            luminColdWhite: {},
            luminWarmWhite: {},
            curEn: this.props.properties[OPERATING_CURRENT.enable],
            curSet: this.props.properties[OPERATING_CURRENT.current],
            curSet2: this.props.properties[OPERATING_CURRENT.current2]
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;

        if (this.getCorrectPropertyName(propertyName) === OPERATING_CURRENT.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
        this.props.handleChange(propertyName, v);
        setTimeout(() => {
            this.props.fetchDriverProperties(this.props.project.id, this.props.driver.driverId).then(e => {
                if (this.props.ledProperties.length > 2) {
                    this.props.ledProperties.map(e => {
                        if (e.info.name === 'led.cf') {
                            this.setState({ luminColdWhite: e })
                        }
                        if (e.info.name === 'led.wf') {
                            this.setState({ luminWarmWhite: e })
                        }
                    })
                }
            })
        }, 2500);
    }

    componentDidMount() {
        this.props.fetchDriverProperties(this.props.project.id, this.props.driver.driverId);
        if (this.props.ledProperties.length > 3) {
            this.props.ledProperties.map(e => {
                if (e.info.name === 'led.cf') {
                    this.state.luminColdWhite = e;
                }
                if (e.info.name === 'led.wf') {
                    this.state.luminWarmWhite = e;

                }
            })
        }

    }

    render() {
        const curEn = this.props.properties[OPERATING_CURRENT.enable];
        const curSet = this.props.properties[OPERATING_CURRENT.current];
        const curSet2 = this.props.properties[OPERATING_CURRENT.current2];
        const curPower = this.props.properties[OPERATING_CURRENT.power];
        const curVoltage = this.props.properties[OPERATING_CURRENT.voltage];
        const curPower2 = this.props.properties[OPERATING_CURRENT.power2];
        const curVoltage2 = this.props.properties[OPERATING_CURRENT.voltage2];

        const UI = {
            Umin: parseFloat(curVoltage?.valueMeta.min || "0"),
            Umax: curVoltage?.valueMeta.max,
            Imin: curSet.valueMeta.min,
            Imax: curSet.valueMeta.max,
            Pmin: curPower?.valueMeta.min,
            Pmax: curPower?.valueMeta.max,
        };

        const UI2 = {
            Umin: parseFloat(curVoltage2?.valueMeta.min || "0"),
            Umax: curVoltage2?.valueMeta.max,
            Imin: curSet2?.valueMeta.min,
            Imax: curSet2?.valueMeta.max,
            Pmin: curPower2?.valueMeta.min,
            Pmax: curPower2?.valueMeta.max,
        };

        let className = '';
        if (!this.state.isEnabled) {
            className += ' card-none';
        }

        let curSet2Card = null;

        if (curSet2) {
            curSet2Card =
                <div style={{ paddingTop: '0.75rem' }}>
                    <Card className={className + " " + this.getClassName([curSet2])} >
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {<Trans i18nKey="Fixed_Current_CH2" />}
                        </div>
                        <Card.Body className={className} style={{ display: "flex" }} disabled={!this.state.isEnabled}>
                            <Col className="card-body-feature-col" style={{ paddingLeft: "0" }}>
                                <Row style={{ fontWeight: "500" }}>
                                    {<Trans i18nKey="Minimum_Current" />}
                                </Row>
                                <Row className="value-current-setting">
                                    {curSet2.valueMeta.min}
                                </Row>
                                <Row className="unit-measure-current-setting">
                                    {'mA'}
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    {(this.props.ledProperties.length > 3 && this.state.luminWarmWhite.info !== undefined) && <PropertyPickerVertical
                                        disabled={true}
                                        property={this.state.luminWarmWhite}
                                        title={'Luminous Flux'}
                                        measureUnit={this.state.luminWarmWhite.info.unit}
                                        min={this.state.luminWarmWhite.valueMeta.min}
                                        max={this.state.luminWarmWhite.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />}
                                    <PropertyPickerVertical
                                        style={{ marginTop: '0.5rem' }}
                                        disabled={!this.state.isEnabled}
                                        property={curSet2}
                                        title={'Operating Current'}
                                        measureUnit={'mA'}
                                        min={curSet2.valueMeta.min}
                                        max={curSet2.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                </Row>
                                <Row>
                                    {(curPower2?.value === '-1' || !curPower2?.value) ? null
                                        :
                                        <CurrentChart
                                            UI={UI2}
                                            I={curSet2.value}
                                            U={curVoltage2?.value === 'Off' ? null : curVoltage2?.value}
                                        />
                                    }
                                </Row>
                            </Col>
                            <Col className="card-body-feature-col" style={{ paddingRight: "0" }}>
                                <Row style={{ fontWeight: "500" }}>
                                    {'Maximum Current'}
                                </Row>
                                <Row className="value-current-setting">
                                    {curSet2.valueMeta.max}
                                </Row>
                                <Row className="unit-measure-current-setting">
                                    {'mA'}
                                </Row>
                            </Col>
                        </Card.Body>
                    </Card>
                </div>
        }

        const currentSettingModesItem = [...currentSettingModes];
        if (curEn.valueMeta.min === (curEn.valueMeta.max)) {
            currentSettingModesItem.splice(0, 1);
        }

        const { t } = this.props;
        for (let i = 0; i < currentSettingModesItem.length; i++) {
            currentSettingModesItem[i].value = t(currentSettingModesItem[i].value)
        }

        const minDim = this.props.properties[OPERATING_CURRENT.mindimming]?.value || 10;
        const lowPower = this.props.properties[OPERATING_CURRENT.lowpower]?.value || 0;

        return (

            // Was className="flex-row" (stylesheet.css: display:flex + flex-direction:row).
            // That leaves align-items at its default `stretch`, so the Current Mode card
            // was pulled to the full height of the sibling column beside it — a card
            // holding one dropdown rendered ~475px tall. items-start lets each child size
            // to its own content.
            //
            // gap-6 replaces the legacy `.flex-row > * { margin-right: 1.5em }`, which
            // also put a trailing margin after the last child.
            <div className="flex items-start gap-6">
                <Card className={this.getClassName([])}>
                    <div className="card-header-feature">
                        {<Trans i18nKey="Current_Mode" />}
                    </div>
                    <Card.Body className="card-body-feature" >
                        <PropertyDropdownUnlabeled
                            translate={true}
                            property={(curEn)}
                            properties={currentSettingModesItem}
                            handleChange={this.handleChange} />
                    </Card.Body>
                </Card>

                <Col>
                    <Card className={className + " " + this.getClassName([this.state.curSet])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {curSet2 ? <Trans i18nKey='Fixed_Current_CH1' /> : <Trans i18nKey="Fixed_Current" />}
                        </div>
                        <Card.Body className={className} style={{ display: "flex" }} disabled={!this.state.isEnabled}>
                            <Col className="card-body-feature-col" style={{ paddingLeft: "0" }}>
                                <Row style={{ fontWeight: "500" }}>
                                    {<Trans i18nKey="Minimum_Current" />}
                                </Row>
                                <Row className="value-current-setting">
                                    {curSet.valueMeta.min}
                                </Row>
                                <Row className="unit-measure-current-setting">
                                    {'mA'}
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    {(this.props.ledProperties.length > 3 && this.state.luminColdWhite.info !== undefined) && <PropertyPickerVertical
                                        disabled={true}
                                        property={this.state.luminColdWhite}
                                        title={'Luminous Flux'}
                                        measureUnit={this.state.luminColdWhite.info.unit}
                                        min={this.state.luminColdWhite.valueMeta.min}
                                        max={this.state.luminColdWhite.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                    }
                                    <PropertyPickerVertical
                                        style={{ marginTop: '0.5rem' }}
                                        disabled={!this.state.isEnabled}
                                        property={curSet}
                                        title={<Trans i18nKey="Operating_Current" />}
                                        measureUnit={'mA'}
                                        oninput="this.value = this.value.replace(/[^0-9.]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');"
                                        min={curSet.valueMeta.min}
                                        max={curSet.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                </Row>
                                <Row>
                                    {(curPower?.value === '-1' || !curPower?.value) ? null :
                                        <CurrentChart
                                            UI={UI}
                                            I={curSet.value}
                                            U={curVoltage?.value === 'Off' ? null : curVoltage?.value}
                                            minDim = {minDim}
                                            lowPower = {lowPower}
                                        />
                                    }
                                </Row>
                            </Col>
                            <Col className="card-body-feature-col" style={{ paddingRight: "0" }}>
                                <Row style={{ fontWeight: "500" }}>
                                    {<Trans i18nKey="Maximum_Current" />}
                                </Row>
                                <Row className="value-current-setting">
                                    {curSet.valueMeta.max}
                                </Row>
                                <Row className="unit-measure-current-setting">
                                    {'mA'}
                                </Row>
                            </Col>
                        </Card.Body>
                    </Card>

                    {curSet2Card}

                </Col>
            </div >
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        project: state.project.info,
        driver: state.driver.info,
        ledProperties: state.driver.features[0].properties
    };
};

const mapDispatchToProps = {
    fetchDriverProperties
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(CurrentSetting);
